export default __webpack_public_path__ + "c7646167965d552a6f7050ca7393954d.svg";